import React, { useEffect, useMemo } from 'react';
import { getMappedFeedbacks, reportAttributeDetailStyles, getQuestionsToDisplay, hasAnyExplanation, shouldShowStringAnswer } from './helper';
import { hasVisibleText } from '../../../util/htmlUtils';
import { Avatar, Divider, Grid, Typography } from '@material-ui/core';
import { format, parseISO } from 'date-fns';

// Height of the fixed page header + tabs; scroll resets to this offset when switching attributes
const ATTRIBUTE_NAV_SCROLL_OFFSET = 167;

const QuestionItem = ({ question, classes }) => (
    <Grid className={classes.content} style={{ gap: 0 }}>
        <Typography className={classes.feedbackText} style={{ fontWeight: 600 }}>{question.questionText}</Typography>
        {shouldShowStringAnswer(question) && (
            <Typography className={classes.feedbackText} style={{ marginTop: -8 }}
                dangerouslySetInnerHTML={{ __html: question.answer }}
            />
        )}
        {hasVisibleText(question.explanation) && (
            <Typography className={classes.feedbackText} style={{ marginTop: -8 }}
                dangerouslySetInnerHTML={{ __html: question.explanation }}
            />
        )}
    </Grid>
);

const ContextSection = ({ context, classes }) => (
    <Grid className={classes.content}>
        <Typography className={classes.title}>Feedback Message</Typography>
        <Typography className={classes.feedbackText}
            dangerouslySetInnerHTML={{ __html: context || "" }}
        />
    </Grid>
);

const FeedbackContent = ({ feedback, classes }) => {
    const questionsToDisplay = getQuestionsToDisplay(feedback?.questions);
    const showContext = !hasAnyExplanation(questionsToDisplay) && hasVisibleText(feedback?.context);

    if (questionsToDisplay.length === 0) {
        return <ContextSection context={feedback?.context} classes={classes} />;
    }

    return (
        <>
            {questionsToDisplay.map((q, qIdx) => (
                <QuestionItem key={qIdx} question={q} classes={classes} />
            ))}
            {showContext && <ContextSection context={feedback.context} classes={classes} />}
        </>
    );
};

export const ReportAttributeDetailComponent = ({ reportData, attributeIndex, isSelfReport = false }) => {
    const classes = reportAttributeDetailStyles();

    const mappedFeedbacks = useMemo(() => getMappedFeedbacks(reportData[attributeIndex]), [reportData, attributeIndex]);

    useEffect(() => {
        if (window.scrollY > ATTRIBUTE_NAV_SCROLL_OFFSET) {
            window.scrollTo({
                top: ATTRIBUTE_NAV_SCROLL_OFFSET,
                left: 0,
                behavior: "smooth",
            });
        }
    }, [attributeIndex])

    return (
        <Grid className={`${classes.wrapper} ${isSelfReport ? classes.wrapperSelf : ""}`}>
            {mappedFeedbacks?.map(feedback => (
                <Grid className={classes.listItemWrapper} key={feedback.feedbackId}>
                    <Grid className={classes.feedbackHeader}>
                        <Avatar
                            src={feedback?.imageUrl || ""}
                            alt={feedback?.userName}
                            className={classes.profilePic}
                        />
                        <Typography className={classes.name}>{feedback.userName}</Typography>
                        <Grid className={classes.dateWrapper}>
                            <Typography className={classes.receivedText}>Received on</Typography>
                            <Typography className={classes.date}>{format(parseISO(feedback.date), "do MMMM yyyy")}</Typography>
                        </Grid>
                    </Grid>
                    <Grid className={classes.contentWrapper}>
                        <FeedbackContent feedback={feedback} classes={classes} />
                        {feedback?.suggestions && (
                            <>
                                <Divider className={classes.divider} />
                                <Grid className={classes.content}>
                                    <Typography className={classes.title}>Improvement Suggestions</Typography>
                                    <Typography className={classes.feedbackText}
                                        dangerouslySetInnerHTML={{
                                            __html: feedback.suggestions,
                                        }}
                                    />
                                </Grid>
                            </>
                        )}
                    </Grid>
                </Grid>
            ))}
        </Grid>
    )
}